module.exports = __webpack_public_path__ + "static/media/sobercos.f5f2c203.webp";